<script>
import ListDefault from "../../Utils/Page/ListDefault";
import dayjs from "dayjs";

export default {
    name: "List",
    mixins: [ListDefault],
    data() {
        return {
            lang: this.$ml.get('pages.companyRequest'),

            filter: {
                title: { value: null, type: 'text'},

            },
            tableHeader: [
                //{ label: '#', is_sort: false },
                { key: 'id', is_sort: true },
                { key: 'company_id', is_sort: true, classes: 'text-l' },
                { key: 'user_id', is_sort: true, classes: 'text-l' },
                { key: 'status_id', is_sort: true, classes: 'text-l' },
                { key: 'note', is_sort: true, classes: 'text-l wrap' },
                { key: 'created_at', is_sort: true, classes: 'text-l wrap' },
            ],

            tableBody: {
                'user_id': { type: 'function', function: this.getUser },
                'company_id': { type: 'function', function: this.getCompany },
                'status_id': { type: 'function', function: this.getStatus },
                'created_at': { type: 'function', function: this.getDate },
            },

            apiList: this.$store.getters.getApiUrl('company.request'),
            pageRoute: 'company.request',
            pageRouteCreate: 'company.request.create',
            pageRouteEdit: 'company.request.edit',
            pagePermission: 'company.request',
        }
    },
    methods: {
        getUser(item) {
            if (item.user) {
                return '@' + item.user.name
            }
            return '-'
        },
        getCompany(item) {
            if (item.company) {
                let link = this.$router.resolve({ name: 'company.edit', params: {id: item.company_id}})
                return `<a class="link" href="${ link.href }" target="_blank">${ item.company.company_name }</a>`
            }
            return '-'
        },
        getStatus(item) {
            if (item.status) {
                return item.status.title
            }
            return '-'
        },
        getDate(item) {
            if (item.created_at) {
                return dayjs(item.created_at).format('MM/DD/YYYY HH:mm:ss')
            }
            return '-'
        },
    }
}
</script>

<style scoped>

</style>
